import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e5facbac&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5facbac')) {
      api.createRecord('e5facbac', component.options)
    } else {
      api.reload('e5facbac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e5facbac&", function () {
      api.rerender('e5facbac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/routes/index.vue"
export default component.exports